const SEO_PATHS = {
  Home: { ro: '/', en: '/en' },
  Zones: { ro: '/zone', en: '/en/zones' },
  Zone: { ro: '/%{slug}', en: '/en/%{slug}' },
  ZoneTrails: { ro: '/%{slug}/trasee', en: '/en/%{slug}/trails' },
  ZonePois: { ro: '/%{slug}/poi', en: '/en/%{slug}/pois' },
  Trail: { ro: '/%{zone_slug}/trasee/%{slug}', en: '/en/%{zone_slug}/trails/%{slug}' },
  POI: { ro: '/%{zone_slug}/poi/%{slug}', en: '/en/%{zone_slug}/pois/%{slug}' },
  About: { ro: '/despre-noi', en: '/en/about' },
  Privacy: { ro: '/politica-de-confidentialitate', en: '/en/privacy-policy' },
  UserProfile: { ro: '/u/%{username}', en: '/u/%{username}' },
  UserTrails: { ro: '/u/%{username}/trasee', en: '/en/u/%{username}/trails' },
  UserComments: { ro: '/u/%{username}/comentarii', en: '/en/u/%{username}/comments' },
  UserActivities: { ro: '/u/%{username}/activitati', en: '/en/u/%{username}/activities' },
  PublicActivity: {
    ro: '/u/%{username}/activitati/%{slug}',
    en: '/en/u/%{username}/activities/%{slug}',
  },
}

export function seoPath(routeKey, locale, params = {}) {
  const template = SEO_PATHS[routeKey]?.[locale] ?? SEO_PATHS[routeKey]?.ro
  if (!template) return '/'
  return Object.entries(params).reduce((path, [k, v]) => path.replace(`%{${k}}`, () => v), template)
}

export function seoUrl(routeKey, locale, params = {}) {
  return `${location.origin}${seoPath(routeKey, locale, params)}`
}

// Strip HTML tags from description_html and truncate for meta description.
export function seoDescription(html, length = 160) {
  if (!html) return null
  const div = document.createElement('div')
  div.innerHTML = html
  const text = (div.textContent || '').replaceAll(/\s+/g, ' ').trim()
  return text.length > length ? text.slice(0, length - 3) + '...' : text
}
